import { z } from 'zod';
// ─── Response schemas ───────────────────────────────────────────────────────
export const NotificationSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    kind: z.string(),
    payload: z.record(z.unknown()),
    readAt: z.string().nullable(),
    createdAt: z.string(),
});
export const NotificationListResponseSchema = z.object({
    notifications: z.array(NotificationSchema),
    unreadCount: z.number(),
});
// ─── Request schemas ────────────────────────────────────────────────────────
export const MarkNotificationsReadRequestSchema = z.union([
    z.object({ ids: z.array(z.string().uuid()) }),
    z.object({ all: z.literal(true) }),
]);
